import React, { useEffect, useState } from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getLanguage, getQueryString } from '../../../utils/params';
import { useLocation, Link } from 'react-router-dom';
import { getUsefulBanner, getUsefulMenu } from '../usefulPage.api';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';
// import { useTranslation } from 'react-i18next';

const HeadUseful = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // const { t } = useTranslation();

  const location = useLocation();
  const language = getLanguage(location);
  const [bannerInfo, setBannerInfo] = useState(null);
  const [menuInfo, setMenuInfo] = useState(null);
  // const arrayPath = location.pathname.split('/');
  // const pathName = arrayPath.length === 4 ? arrayPath[3] : arrayPath[2];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    showLoader();
    getUsefulBanner(getQueryString({ language })).then(res => {
      if (res) {
        setBannerInfo(res);
      }
    });

    getUsefulMenu(getQueryString({ language })).then(res => {
      if (res) {
        setMenuInfo(res);
      }
    });
    hideLoader();
    //eslint-disable-next-line
  }, [language]);

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  return (
    <>
      {bannerInfo !== null ? (
        <div id="usefulBanner">
          <div className="useful-banner">
            <div className="banner-wrap-text">
              <div className={`banner-text-head ${language === 'jp' ? 'font-noto-serif-cjk-jp' : '' }`} dangerouslySetInnerHTML={createMarkup(bannerInfo.title)}></div>
              <div className="banner-red-line col-2 my-3"></div>
              <div
                className="banner-text-content jp-font-sawarabi-gothic"
                dangerouslySetInnerHTML={createMarkup(bannerInfo.descriptions)}
              ></div>
            </div>
            <div className="banner-color-overlay"></div>
            <img
              style={{ height: '100%', width: '100%' }}
              src={`${process.env.REACT_APP_ISN_IMAGE_URL}${bannerInfo.imageUrl}`}
              alt="banner"
            />
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="container">
        <div className="slide-category">
          <div className="row">
            {menuInfo && menuInfo.length
              ? menuInfo.map((item, index) => {
                  return (
                    <div className="col-md menu-item mt-3 mt-md-0" key={index}>
                      <Link
                        to={
                          item.slug === 'about-renting-an-apartment-office-in-vietnam'
                            ? `/${language}/useful-information/${item.slug}/area-guide`
                            : `/${language}/useful-information/${item.slug}`
                        }
                      >
                        <div
                          className={`slug ${location.pathname.includes(item.slug) ? 'actived' : ''} `}
                          slug={item.slug}
                        >
                          <img
                            className="image"
                            src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`}
                            alt=""
                          />
                          <div className="category-name">{item.title}</div>
                        </div>
                      </Link>
                    </div>
                  );
                })
              : ''}
          </div>
        </div>
      </div>

      {/* <div className="slide-category d-block d-md-none">
        <div className="container">
          <div className="row">
            {menu && menu.length
              ? menu.map((item, index) => (
                  <div className="col-12" key={index}>
                    <Link to={item.url}>
                      <div
                        className={`slug ${location.pathname.includes(item.tag) ? 'actived' : ''} `}
                        slug={item.slug}
                      >
                        <img className="image" src={item.image} alt="" />
                        <div className="category-name">{item.categoryName}</div>
                      </div>
                    </Link>
                  </div>
                ))
              : ''}
          </div>
        </div>
      </div> */}
      {loader}
    </>
  );
};

export default HeadUseful;
